import script from "./ButtonContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonContent.vue?vue&type=script&setup=true&lang=js"

import "./ButtonContent.vue?vue&type=style&index=0&id=47bf1556&lang=postcss&scoped=true"
script.__scopeId = "data-v-47bf1556"

export default script